<template>
  <v-card
    class="prompt-card pa-3 cursor-pointer d-flex"
    outlined
    elevation="0"
    :disabled="disabled"
    @click="$emit('handlePromptInteraction', item.prompt)"
  >
    <div class="d-flex align-center card-icon">
      <EntityIcon
        circle
        size="16"
        active
        :entityType="item.type"
        class="me-1"
      />
    </div>
    <div class="d-flex flex-column justify-center ml-2">
      <span class="body-3 font-bold">{{ item.title }}</span>
      <span class="caption blue-grey--text mt-1">{{ item.description }}</span>
    </div>
  </v-card>
</template>

<script>
import EntityIcon from '@/components/EntityIcon.vue'

export default {
  name: 'PromptItem',

  components: {
    EntityIcon,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.prompt-card:hover {
  border: 1px solid $color-blue-lighten1 !important;
  .card-icon {
    animation: breathing 1.5s ease-in-out infinite;
  }
}
@keyframes breathing {
  0% {
    transform: scale(1); /* Starts slightly smaller */
  }
  50% {
    transform: scale(1.2); /* Expands to a larger size (inhale) */
  }
  100% {
    transform: scale(1); /* Contracts back to original size (exhale) */
  }
}
</style>
